import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RXNote } from '../../../../shared/models/order.model';

// What an imported case carried that the RX has no place for (an IMPORT_DETAILS note), kept apart from the free notes:
// read only, removable like the notes from the bank.
@Component({
  selector: 'rx-import-details-note',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './import-details-note.component.html',
  styleUrls: ['./import-details-note.component.scss'],
})
export class ImportDetailsNoteComponent {
  @Input() note: RXNote;
  @Input() readOnly = false;
  @Output() remove = new EventEmitter<void>();
}
